import React from 'react';
import withIcon from '../utilities/withIcon'; 

const IconNest = () => {
  return (
    <g>
      <path
        d="m1.05 0 13.901.015c.54 0 .986.41 1.043.936l.006.114V5.95c0 .541-.41.987-.936 1.044L14.95 7H4.483l-.001 4.75H9v-1.7c0-.54.41-.986.936-1.043l.114-.006 4.903.014c.54.001.984.41 1.04.935l.007.115v4.885c0 .541-.41.987-.936 1.044L14.95 16h-4.9a1.05 1.05 0 0 1-1.044-.936L9 14.95v-1.7H3.733a.75.75 0 0 1-.743-.648l-.007-.102V7H1.05a1.05 1.05 0 0 1-1.044-.936L0 5.95v-4.9C0 .51.41.063.936.006L1.051 0zm9.45 10.501V14.5h4v-3.987l-4-.012zM1.5 1.5v4h13V1.515L1.5 1.5z"
        
      />
    </g>
  );
};


export default withIcon(IconNest);
